module.exports = __webpack_public_path__ + "static/media/FCPSRcalendars.44ca4e0d.svg";